import { type ErrorsHandbook, ErrorsHandbookBuilder } from '@/6_shared/api'
import { createErrorHandbook } from '@/6_shared/api'

export const categoryErrorsHandbook: ErrorsHandbook = createErrorHandbook({
  ...new ErrorsHandbookBuilder(404).build(),
  ...new ErrorsHandbookBuilder(500).build()
})
